import React from 'react';

import styled from "styled-components";
import { useTranslation } from 'react-i18next';

import { ButtonStyle } from '../global/parts/buttons';
import { FaLongArrowAltLeft } from 'react-icons/fa';

const ProjectDetailStyled = styled.div`
    overflow: hidden;
    .canvas {
        margin: 0;
        width: 100vw;
        min-height: 100vh;
        background-color: var(--backgroundc);
        position: relative;
        box-sizing: border-box;
        z-index: 0;
    }
    &.is-logo-cover .hero-stack {
        @media (max-width: 1022px) {
            display: flex;
            flex-direction: column;
            gap: 3vh;
            padding: 11vh var(--marginborder) 0;
            width: 100%;
            box-sizing: border-box;
        }
    }
    &.is-logo-cover .projectdetailname {
        @media (max-width: 1022px) {
            order: 1;
            top: 0;
            height: auto;
            width: 100%;
            padding: 0;
            font-size: clamp(1.75rem, 7vw, 2.75rem);
            line-height: 1.15;
            z-index: 2;
        }
    }
    &.is-logo-cover .projectdetailshortdesc {
        @media (max-width: 1022px) {
            position: relative;
            margin: 1vh 0 0;
            width: 100%;
            font-size: var(--fontsizecontentc);
            line-height: 1.4;
        }
    }
    &.is-logo-cover .projectpicture {
        @media (max-width: 1022px) {
            top: 0;
            order: 2;
            flex-shrink: 0;
            min-width: 0;
            width: 100%;
            min-height: 0;
            height: clamp(130px, 40vw, 210px);
            max-height: 210px;
            margin: 3vh 0 4vh;
            padding: 4vh 8vw;
            box-sizing: border-box;
            z-index: 1;
            border-radius: var(--radius-md);
            background-size: 68% auto;
        }
    }
    &.is-logo-cover .projectdetaildesc {
        @media (max-width: 1022px) {
            top: 0;
            padding-top: 0;
        }
    }
    &.is-logo-cover .arrowback {
        @media (max-width: 1022px) {
            position: fixed;
            top: calc(var(--marginborder) + 1vh);
            left: var(--marginborder);
            z-index: 60;
        }
    }
    .sitenamecontainer {
        background-color: transparent;
        color: var(--textb);
        font-size: var(--fontsizeborder);
        font-weight: bold;
        text-align: right;
        position: relative;
        z-index: 5;
        padding: var(--marginborder);
        padding-bottom: 0;
        margin: auto;
        margin-right: 0px;
        width: 25vw;
        @media (min-width: 1023px) {
            display: none;
        }
    }
    .sitename{
        background-color: transparent;
        color: var(--textb);
    }
    .projectdetailname{
        text-align: left;
        font-size: var(--fontsizetitleb);
        font-weight: 500;
        position: relative;
        color: var(--textb);
        background-color: transparent;
        opacity: 1;
        z-index: 5;
        width: 77vw;
        height: 50vh;
        top: 8vh;
        padding: var(--marginborder);
        @media (min-width: 1023px) {
            padding: var(--margin);
            font-size: var(--fontsizetitlea);
        }
    }
    .projectdetailshortdesc{
        text-align: left;
        font-size: var(--fontsizecontentb);
        font-weight: 3;
        position: absolute;
        color: var(--textb);
        background-color: transparent;
        margin: 1vh;
        width: 77vw;
        opacity: 1;
        z-index: 5;
        @media (min-width: 1023px) {
            font-size: var(--fontsizecontenta);
        }
    }
    /* ratio 2880*1638 */
    .projectpicture{
        min-width: 100vw;
        min-height: 56.8vw;
        position: relative;
        background-image: url(${props => props.img});
        background-color: ${props =>
            props.heroBackground || (props.logoCover ? 'var(--color-hero-muted)' : 'transparent')};
        background-position: ${props => props.logoCover ? 'center center' : 'top center'};
        background-size: ${props => props.logoCover ? 'contain' : 'cover'};
        background-repeat: no-repeat;
        box-sizing: border-box;
        opacity: 1;
        z-index: 1;
        top: -13vh;
        ${props => props.logoCover && `
            @media (min-width: 1023px) {
                min-height: 32vw;
                background-size: 50% auto;
            }
        `}
        @media (min-width: 1023px) {
            min-width: 70vw;
            min-height: ${props => props.logoCover ? '32vw' : '39.8125vw'};
            margin-left: 30vw;
            border-radius: var(--radius-lg);
        }
    }
    .projectdetaildesc{
        text-align: center;
        font-size: var(--fontsizecontentb);
        font-weight: 20;
        position: relative;
        color: var(--textb);
        background-color: transparent;
        padding: var(--marginborder);
        opacity: 1;
        z-index: 3;
        object-fit: cover;
        top: -13vh;
        @media (min-width: 1023px) {
            padding: var(--margin);
            padding-bottom: var(--marginhalf);
        }
    }
    .button{
        margin-top: 7vh;
        margin-bottom: 4vh;
    }
    .arrowback{
        position: relative;
        top: 8.3vh;
        left: var(--marginborder);
        font-size: 3vh;
        z-index: 6;
        width: 20vw;
        color: var(--textb);
        @media (min-width: 1023px) {
            top: 13vh;
            left: var(--margin);
            font-size: 5vh;
        }
    }
`;

function ProjectDetailPage({
    projectdetailname,
    projectdetailshortdesc,
    projectdetaildesc,
    coverimg,
    projectsite,
    backHref = '/projects',
    heroBackground,
    logoCover = false,
    visitLabelKey = 'ProjectDetailPage.visit',
}) {
    const [t] = useTranslation();

    const hero = (
        <>
            <div className="projectdetailname">
                {projectdetailname}
                <div className="projectdetailshortdesc">
                    {projectdetailshortdesc}
                </div>
            </div>
            <div className="projectpicture" />
        </>
    );

    return (
        <ProjectDetailStyled
            className={logoCover ? 'is-logo-cover' : undefined}
            img={coverimg}
            heroBackground={heroBackground}
            logoCover={logoCover}
        >
            <div className="canvas">
                <a href={backHref} style={{ textDecoration: "none" }}>
                    <div className=" arrowback">
                        <FaLongArrowAltLeft />
                    </div>
                </a>
                <div className="sitenamecontainer">
                    <a href="/" style={{ textDecoration: "none" }}>
                        <div className='sitename'>
                            {t('TopBorder.SiteName')}
                        </div>
                    </a>
                </div>
                {logoCover ? <div className="hero-stack">{hero}</div> : hero}
                <div className="projectdetaildesc">
                    {projectdetaildesc}
                    <br />
                    <a href={projectsite} target="_blank" rel="noreferrer">
                        <div className='button'>
                            <ButtonStyle>{t(visitLabelKey)}</ButtonStyle>
                        </div>
                    </a>
                </div>
            </div>
        </ProjectDetailStyled>
    )
}

export default ProjectDetailPage;